import railsData from 'utilities/rails-data';
import {StringMap} from 'utilities/types';

type AllowedLanguages = StringMap<string>;
type LanguageLabel = string;

export const Profile = {
  getLanguageMap(): AllowedLanguages {
    return railsData('profile.languageList');
  },

  getLanguageLabel(languageKey: string): LanguageLabel {
    return this.getLanguageMap()[languageKey];
  },
};
